import React from "react";
import GreenDotIcon from "../../assets/img/GreenDotIcon.svg";
import GreenRightIcon from "../../assets/img/GreenRightIcon.svg";
import { BaseButton, BaseStatusLabel } from "../base";
import { Order } from "../../store/slices/order/types";
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
const OrganisationOrderItem = ({ order }: { order: Order }) => {
  // const handleRes = () => {
  //   handleShowModal();
  //   setOrder(order);
  // };
  const navigate = useNavigate();
  return (
    <>
      <div
        onClick={() => navigate(`/dashboard/orders/${order?._id}`)}
        className="flex cursor-pointer flex-col cursor-pointer md:flex-row md:justify-between md:items-center bg-white px-4 py-6 rounded-[0.5rem] mb-6  shadow-md"
      >
        <div className="lg:w-2/3 flex flex-col sm:flex-row md:items-center ">
          <div className="lg:w-1/2 mb-2 md:mb-0">
            <div className="flex items-center">
              <img src={GreenDotIcon} alt="green dot icon" className="" />
              <h3 className="text-[1rem] font-[500] text-[#0C4654] font-[500] mx-2">
                {order?.user?.firstName} {order?.user?.lastName},{" "}
                {order?.uniqueId}
              </h3>
            </div>
            <div className="flex max-w-full">
              {order?.products?.length > 0 ? (
                order?.products?.slice(0, 3).map((product) => (
                  <div className="flex items-center mr-2" key={product?._id}>
                    <div>
                      <img
                        src={GreenDotIcon}
                        alt="green dot icon"
                        className="w-1 h-1 mx-1"
                      />
                    </div>
                    <p className="text-[0.625rem] text-[#0C4654]">
                      {product.name}
                    </p>
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="">
            <BaseStatusLabel status={order?.orderStatus} />
          </div>
        </div>
        <div className="flex items-center text-[#0C4654]">
          <p className="mx-2 font-[500]">View Order</p>
          <BsArrowRight />
        </div>
      </div>
    </>
  );
};

export default OrganisationOrderItem;
